<template>
  <main>
    <van-cell-group>
      <van-field
        v-model="hospital"
        label="医院"
        placeholder="请选择医院"
        readonly
      />
      <van-field
        v-model="relation"
        label="关系"
        placeholder="请输入关系"
        readonly
        @click="onShowActionSheetRelation"
      />
      <van-field
        v-model="medicalCardId"
        clearable
        label="就诊卡号"
        placeholder="请输入就诊卡号"
      />
      <van-field
        v-show="hospitalId !== 8"
        v-model="name"
        clearable
        label="申请人姓名"
        placeholder="请输入申请人姓名"
      />
      <van-field
        v-show="hospitalId !== 8"
        v-model="idCardCode"
        clearable
        label="二代身份证"
        placeholder="请输入二代身份证"
      />
      <van-field
        v-show="hospitalId !== 8"
        v-model="phone"
        type="tel"
        clearable
        label="手机号"
        placeholder="请输入手机号"
      />
      <van-field
        v-show="hospitalId === 8"
        :icon="pwd.icon"
        v-model="chpwd"
        :type="pwd.type"
        clearable
        label="就诊卡密码"
        placeholder="请输入密码"
        @click-icon="showPwd"
      >
      </van-field>
      <van-field
        v-show="hospitalId === 8"
        v-model="SMS"
        clearable
        label="短信验证码"
        placeholder="请输入短信验证码"
      >
        <van-button
          slot="button"
          :disabled="SMSTime !== '获取短信'"
          size="small"
          type="primary"
          @click="getPhone">{{ SMSTime | sms }}</van-button>
      </van-field>
    </van-cell-group>
    <div
      v-show="hintShow"
      style="font-size: 12px;"
      class="mt-2 pl-3">
      <span>短信验证码已发送到<span style="color: orange;">{{ phone | mask }}</span>, 请注意查收</span>
    </div>
    <div class="p-3">
      <van-row class="pb-2">
        <van-col span="24">
          <van-button
            type="primary"
            size="large"
            @click="handleSubmit">绑定就诊卡</van-button>
        </van-col>
      </van-row>
    </div>
    <van-actionsheet
      v-model="showRelation"
      :actions="actionsRelation"
      cancel-text="取消"
      @select="onSelectRelation"
      @cancel="onCancelRelation"
    />
    <van-dialog
      ref="SMSDialog"
      v-model="SMSShow"
      :before-close="sendSMS"
      show-cancel-button>
      <img
        :src="imgpwdSrc"
        width="100%">
      <van-field
        v-model="imgpwd"
        placeholder="输入图形验证码"
        @click-icon="getImg">
        <div
          slot="icon"
          class="refresh">
          <img
            src="@/assets/refresh.png"
            height="24px">
        </div>
      </van-field>
    </van-dialog>
  </main>
</template>

<script>
import { apiURL } from '@/libs/const';

export default {
  name: 'CardBind',
  filters: {
    mask: (value) => {
      if (value === '') {
        return '';
      }
      return `${value.substr(0, 3)}******${value.substr(9)}`;
    },
    sms: (value) => {
      if (value === '获取短信') {
        return value;
      }
      return `${value}s`;
    },
  },
  data() {
    return {
      name: '',
      idCardCode: '',
      phone: '',
      medicalCardId: '',
      relation: '',
      hospital: '',
      hospitalMap: null,
      hospitalId: '',
      showRelation: false,
      showHospital: false,
      actionsRelation: [
        {
          name: '本人',
        },
        {
          name: '父母',
        },
        {
          name: '子女',
        },
        {
          name: '兄弟姐妹',
        },
        {
          name: '伴侣',
        },
        {
          name: '其他',
        },
      ],
      actionsHospital: [],
      // 澄海专用
      pwd: {
        state: 0,
        icon: 'password-not-view',
        type: 'password',
      },
      chpwd: '', // 就诊卡密码
      imgpwd: '', // 图形验证码
      imgpwdSrc: '', // 图形验证码图片url
      SMS: '',
      SMSShow: false,
      SMSTime: '获取短信',
      SMSTimer: null,
      hintShow: false,
    };
  },
  mounted() {
    // this.handleLoadHospital();
    this.pageInit();
  },
  activated() {
    this.pageInit();
  },
  methods: {
    async getPhone() {
      // 澄海绑卡 - 1: 获取手机号码
      if (this.medicalCardId.length > 0 && this.chpwd.length > 0) {
        if (this.phone === '') {
          this.phone = await this.$http.get('/patient-api/webapi/user/getMedicalCardPhone', {
            medicalCardId: this.medicalCardId,
            password: this.chpwd,
            hospitalId: 8,
          });
        }
        this.getImg();
        this.SMSShow = true;
      } else {
        this.$toast.fail('请先输入就诊卡和密码');
      }
    },
    getImg() {
      // 澄海绑卡 - 2: 获取图形验证码
      this.imgpwd = '';
      if (this.phone.length) {
        this.imgpwdSrc = `${apiURL}/patient-api/webapi/hospital-patient/get-image-captcha?captcha_type=CHENGHAI_BIND_CARD&phone=${this.phone}&t=${Number(new Date())}`;
      } else {
        this.$toast.fail('请先输入就诊卡和密码');
      }
    },
    // 显示就诊卡密码
    showPwd() {
      if (this.pwd.state === 0) {
        this.pwd.state = 1;
        this.pwd.icon = 'password-view';
        this.pwd.type = '';
      } else {
        this.pwd.state = 0;
        this.pwd.icon = 'password-not-view';
        this.pwd.type = 'password';
      }
    },
    pageInit() {
      this.name = '';
      this.idCardCode = '';
      this.phone = '';
      this.medicalCardId = '';
      this.relation = '';
      this.hospital = sessionStorage.getItem('bindHospitalName');
      this.hospitalId = parseInt(sessionStorage.getItem('bindHospitalId'), 10);
      this.chpwd = '';
      this.imgpwd = '';
      this.imgpwdSrc = '';
      this.pwd = {
        state: 0,
        icon: 'password-not-view',
        type: 'password',
      };
      // this.SMS = false;
      this.SMS = '';
      this.SMSTime = '获取短信';
      this.SMSTimer = null;
      this.hintShow = false;
    },
    // 关系
    onShowActionSheetRelation() {
      this.showRelation = true;
    },
    onSelectRelation(item) {
      this.relation = item.name;
      this.showRelation = false;
    },
    onCancelRelation() {
      this.showRelation = false;
    },
    async sendSMS(action, done) {
      // 澄海绑卡 - 3: 发送短信验证码
      if (action === 'confirm') {
        try {
          if (this.SMSTimer === null) {
            await this.$http.post('/patient-api/webapi/hospital-patient/send-sms-captcha', {
              phone: this.phone,
              // phone: '15918778473',
              captcha_type: 'ChenghaiBindCard',
              image_captcha: this.imgpwd,
            });
            this.SMSTime = 60;
            const self = this;
            this.SMSTimer = setInterval(() => {
              if (self.SMSTime > 0) {
                self.SMSTime -= 1;
              } else {
                self.SMSTimer = null;
                self.SMSTime = '获取短信';
              }
            }, 1000);
            this.hintShow = true;
            done();
          }
        } catch (error) {
          this.$refs.SMSDialog.loading.confirm = false;
          this.getImg();
        }
      } else {
        this.imgpwd = '';
        this.SMS = '';
        this.getImg();
        done();
      }
    },
    // 绑卡
    async handleSubmit() {
      if (this.hospitalId !== 8) {
        // 不是澄海医院
        const {
          name, phone, relation, idCardCode, medicalCardId, hospitalId,
        } = this;

        await this.$http.post('/patient-api/webapi/user/bind-medical-card', {
          name,
          phone,
          relation,
          id_card_code: idCardCode,
          medical_card_id: medicalCardId,
          hospital_id: hospitalId,
        });
        this.$toast.success('绑卡成功');
        this.$router.back();
      } else {
        // 澄海绑卡 - 4: 绑卡
        await this.$http.post('/patient-api/webapi/user/bindMedicalCardChenghai', {
          medicalCardId: this.medicalCardId,
          password: this.chpwd,
          relation: this.relation,
          captcha: this.SMS,
        });
        clearInterval(this.SMSTimer);
        this.SMSTimer = null;
        this.chpwd = '';
        this.$router.push({ name: 'card' });
      }
    },
  },
};
</script>


<style>
 .van-dialog__confirm {
    background-color: #38f;
    color: #FFF;
 }
</style>

<style lang="scss" scoped>
  .refresh {
    padding-top: 4.2px;
  }
</style>

